import React from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts"; // Import echarts directly
import { useTheme } from "@mui/material/styles"; // Import useTheme from MUI
import { useTranslation } from "react-i18next";
import NoDataText from "../NoDataText/NoDataText";
const SeriesBarChart = ({ data }) => {
	const { t } = useTranslation();
	const toNumber = (value) => {
		const parsed = Number(value);
		return Number.isFinite(parsed) ? parsed : 0;
	};
	// Access the MUI theme
	const theme = useTheme();

	// Check if the data is empty
	if (!data || Object.keys(data).length === 0) {
		return <NoDataText />;
	}

	// Prepare the chart options
	const categoryLabels = data.customers || data.sites || data.labels || [];
	const siteNumbers = Array.isArray(data.site_numbers) ? data.site_numbers : [];
	const categoryLabel =
		Array.isArray(data.customers) ? "Customer" : Array.isArray(data.sites) ? "Site" : "Category";

	const option = {
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
			formatter: (params) => {
				const orderCount = toNumber(params?.[0]?.value);
				const revenue = toNumber(params?.[1]?.value);
				const index = params?.[0]?.dataIndex ?? 0;
				const siteInfo = siteNumbers[index];
				const siteLine = siteInfo ? `Site #: ${siteInfo}<br />` : "";
				return `
          <strong>${categoryLabel}: ${params[0].name}</strong><br />
          ${siteLine}
          Orders: ${orderCount}<br />
          Total Revenue: $${revenue.toFixed(2)}
        `;
			},
		},
		grid: {
			left: "3%",
			right: "4%",
			bottom: "3%",
			containLabel: true,
		},
		xAxis: [
			{
				type: "category",
				data: categoryLabels,
				axisTick: {
					alignWithLabel: true,
				},
			},
		],
		yAxis: [
			{
				type: "value",
				name: t('UI_TEXT.ORDERS_1'),
				min: 0,
				axisLabel: {
					formatter: "{value}",
				},
			},
			{
				type: "value",
				name: "Revenue",
				min: 0,
				axisLabel: {
					formatter: "$ {value}",
				},
				splitLine: {
					show: false,
				},
			},
		],
		legend: {
			orient: "horizontal",
			left: "center",
			// top: "top",
			bottom: "bottom",
		},
		series: [
			{
				name: t('UI_TEXT.ORDERS_1'),
				type: "bar",
				barWidth: "40%",
				data: data.counts, // Use the counts as the data for the bars
				itemStyle: {
					color: theme.palette.primary.main, // Bar color using MUI primary color
				},
				emphasis: {
					itemStyle: {
						color: theme.palette.primary.dark,
					},
				},
				yAxisIndex: 0, // Associate with the primary Y-Axis (Orders #)
			},
			{
				name: t('DASHBOARD.TOTAL_REVENUE'),
				type: "bar",
				barWidth: "40%",
				data: data.revenues, // Use the revenues as the data for the bars
				itemStyle: {
					color: theme.palette.secondary.main, // Bar color using MUI secondary color
				},
				emphasis: {
					itemStyle: {
						color: theme.palette.secondary.dark,
					},
				},
				yAxisIndex: 1, // Associate with the secondary Y-Axis (Revenue)
			},
		],
	};

	return <ReactECharts option={option} style={{ height: "100%", width: "100%", marginTop: "5px" }} />;
};

export default SeriesBarChart;
